
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QueryType } from 'enums/QueryType';
import { ExpressionFilterModel } from './Models.ExpressionFilter';
import { Model, ModelProperty } from 'models/Model';


export class DynamicQueryModel extends Model<DynamicQueryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'queryType', type: 'QueryType', languageString: 'dynamicQuery.property.queryType' },
		{ name: 'filters', type: 'ExpressionFilterModel[]', languageString: 'dynamicQuery.property.filters', isHidden: true, isArray: true, isObject: true, new: () => { return new ExpressionFilterModel }, properties: () => { return ExpressionFilterModel.classProperties } },
		{ name: 'selectProperties', type: 'SelectPropertyModel[]', languageString: 'dynamicQuery.property.selectProperties', isHidden: true, isArray: true, isObject: true, new: () => { return new SelectPropertyModel }, properties: () => { return SelectPropertyModel.classProperties } }
	];
	[key: string]: any;
	
	public queryType: QueryType;
	public filters: ExpressionFilterModel[];
	public selectProperties: SelectPropertyModel[];
    
	constructor(){
		super();
		this.queryType = 0;
		this.filters = [];
		this.selectProperties = [];
		
	}
	getProperties(){
		return DynamicQueryModel.classProperties;
	}
}
export class SelectPropertyModel extends Model<SelectPropertyModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string', languageString: 'selectProperty.property.name' },
		{ name: 'type', type: 'string', languageString: 'selectProperty.property.type' },
		{ name: 'isArray', type: 'boolean', languageString: 'selectProperty.property.isArray' },
		{ name: 'isHidden', type: 'boolean', languageString: 'selectProperty.property.isHidden' },
		{ name: 'aggregationType', type: 'AggregationEnum', languageString: 'selectProperty.property.aggregationType' }
	];
	[key: string]: any;
	
	public name: string;
	public type: string;
	public isArray: boolean;
	public isHidden: boolean;
	public aggregationType?: AggregationEnum;
    
	constructor(){
		super();
		this.name = '';
		this.type = '';
		this.isArray = false;
		this.isHidden = false;
		this.aggregationType = undefined;
		
	}
	getProperties(){
		return SelectPropertyModel.classProperties;
	}
}

export enum AggregationEnum{
	Count = 0,
	Sum = 1,
	Min = 2,
	Max = 3
}
export namespace AggregationEnum {
	export function getKeys(): Map<AggregationEnum, string> {
		return new Map([[0, 'Count'], [1, 'Sum'], [2, 'Min'], [3, 'Max']]);
	}
}
